import type { Report } from "./api/index.js";

/** A report the server explicitly says is still owned by onboarding. */
export function isUnfinished(report: Report): boolean {
  return report.status === "setup";
}
